import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import arrow from "../../assets/svg/arrowRightNew.svg";
import axios from "../../components/Hooks/axios";
import SelectedImage from "./SelectedImage";
import styles from "./StoryWrapper.module.scss";
import TextBox from "./TextBox";
import WebcamCapture from "./WebcamCapture";
import { CropEasy } from "./crop/CropEasy";

import { validateMediaFile, getFriendlyUploadErrorMessage } from "../../utils/fileValidation";
import AskFameoAssistantModal from "../../components/AskFameo/AskFameoAssistantModal";
import { cleanCaptionSentence } from "../../utils/cleanCaptionSentence";
import { PiMagicWandFill } from "react-icons/pi";

const StoryUploadButtons = ({ setStoryPopup, setOwnRel, setIsHeaderOpen }) => {
	const { userId } = useSelector((state) => state.auth);
	const [openCrop, setOpenCrop] = useState(false);
	const [photoURL, setPhotoURL] = useState("");
	const [textBox, setTextBox] = useState(false);
	const [storyAiText, setStoryAiText] = useState("");
	const [showStoryAiModal, setShowStoryAiModal] = useState(false);
	const [openWebCame, setOpenWebCame] = useState(false);
	const [selectedImageShow, setSelectedImageShow] = useState(false);
	const [imagesArray, setImagesArray] = useState([]);
	const image = useRef();
	const [btnDisable, setBtnDisable] = useState(false);
	const [uploadPer, setUploadPer] = useState(0);

	const handleFileInputChange = (e) => {
		const file = e.target.files;
		if (file && file.length > 0) {
			const isVideo = file[0].type?.startsWith("video") || file[0].type === "video/mp4";
			if (isVideo) {
				const validation = validateMediaFile(file[0]);
				if (!validation.valid) {
					toast.error(validation.error);
					e.target.value = null;
					return;
				}

				setBtnDisable(true);
				const id = toast.loading("Story Uploading...");
				const formData = new FormData();
				formData.append("userId", userId);
				formData.append("mediaType", "video");
				formData.append("mediaUrl", file[0]);

				axios
					.post("/story", formData, {
						onUploadProgress: (progressEvent) => {
							const progress = (progressEvent.loaded / progressEvent.total) * 100;
							setUploadPer(progress);
						},
					})
					.then(({ data }) => {
						console.log(data);
						setBtnDisable(false);
						toast.update(id, { render: data.message, type: "success", isLoading: false, autoClose: 2000 });
						setOwnRel(Math.random());
						setStoryPopup(false);
					})
					.catch((err) => {
						console.error(err);
						setBtnDisable(false);
						setUploadPer(0);
						const errorMsg = getFriendlyUploadErrorMessage(err, "Failed to upload story");
						toast.update(id, { render: errorMsg, type: "error", isLoading: false, autoClose: 3000 });
					});
			} else {
				const filesArr = Array.from(file);
				for (const f of filesArr) {
					const validation = validateMediaFile(f);
					if (!validation.valid) {
						toast.error(validation.error);
						e.target.value = null;
						return;
					}
				}
				setSelectedImageShow(true);
				setImagesArray(filesArr);
			}
		}

		e.target.value = null;
	};

	// Check if imagesArray length has changed and update header state accordingly
	useEffect(() => {
		if (imagesArray.length > 0) {
			console.log(imagesArray); setIsHeaderOpen(true)
		}
	}, [imagesArray.length])

	const Controls = () => {
		return (
			<div className={styles.Controls}>
				{/* <h1>Update fameo-X</h1> */}
				<h1>Update fameo-X</h1>
				<h4>Drag & Drop your image or video</h4>
				<h4>Or</h4>
				<div className={styles.buttonContainer}>
					<button className={styles.button} onClick={() => { setTextBox(true); setIsHeaderOpen(true) }}>
						Text
					</button>
					<button className={styles.button} onClick={() => toast.info("VMagz Coming Soon...")}>
						VMagz
					</button>
					<button className={styles.button} onClick={() => setOpenWebCame(true)}>
						Camera
					</button>
					<button
						className={styles.button}
						onClick={() => {
							if (!btnDisable) image.current.click();
						}}
						disabled={btnDisable}>
						Upload From Computer
						<span style={{ width: `${uploadPer}%` }}></span>
					</button>
				</div>
				<input type="file" multiple ref={image} style={{ display: "none" }} onChange={handleFileInputChange} accept=".jpg,.jpeg,.png,.webp,.gif,.svg,.mp4,.mov,.webm,.ogg,image/jpeg,image/png,image/webp,image/gif,video/mp4,video/quicktime,video/webm" />
			</div>
		);
	};

	return (
		<div className={styles.StoryUploadButtons}>
			<div className={styles.PopupContainer}>
				{!textBox && !selectedImageShow && !openCrop && <Controls />}
				{textBox && (
					<TextBox
						setStoryPopup={setStoryPopup}
						setOwnRel={setOwnRel}
						initialText={storyAiText}
					/>
				)}
				{openWebCame && (
					<WebcamCapture setOpenWebCame={setOpenWebCame} setImageArray={setImagesArray} setOpenCrop={setOpenCrop} />
				)}
				{selectedImageShow && (
					<SelectedImage
						imageArray={imagesArray}
						setImageArray={setImagesArray}
						setSelectedImageShow={setSelectedImageShow}
						setOpenCrop={setOpenCrop}
					/>
				)}
				{openCrop && (
					<CropEasy {...{ imagesArray, setImagesArray, setOpenCrop, setSelectedImageShow, setStoryPopup, setOwnRel }} />
				)}
			</div>

		</div>
	);
};

export default StoryUploadButtons;


